module.exports = __webpack_public_path__ + "static/media/digmentha-bottom.dcde3c9a.svg";